import { render, staticRenderFns } from "./statisticsLine.vue?vue&type=template&id=35316f05&scoped=true&"
import script from "./statisticsLine.vue?vue&type=script&lang=js&"
export * from "./statisticsLine.vue?vue&type=script&lang=js&"
import style0 from "./statisticsLine.vue?vue&type=style&index=0&id=35316f05&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35316f05",
  null
  
)

export default component.exports